import { Box } from "@mui/material";
import { format } from "date-fns";
import { t } from "i18next";
import { useEffect, useState } from "react";
import BaseTable from "../../../../components/table/BaseTable";
import { useAxiosPrivate } from "../../../../hooks/useAxiosPrivate";
import { useCustomerOffers } from "../../../../services/offersService";
import { productsApi } from "../../../../services/productsService";
import { getCalculatedPricingForProductDiscounted } from "../../../../utils";
import { OfferManageButton } from "../../../OffersPage/OfferManageButton";
import { OfferStatusText } from "../../../OffersPage/OfferStatusText";
import InfoIcon from "@mui/icons-material/Info";
import FiaskoEditDialog from "../../../../components/dialog/FiaskoEditDialog/FiaskoEditDialog";
import { useDialogBetter } from "../../../../hooks/useDialogBetter";

const HEADERS = [
    // t("clients.ClientPassportOfferTable.offerNumber"),
    t("clients.ClientPassportOfferTable.dateCreated"),
    t("clients.ClientPassportOfferTable.investmentName"),
    t("clients.ClientPassportOfferTable.productNames"),
    t("clients.ClientPassportOfferTable.productPricesBrutto"),
    t("clients.ClientPassportOfferTable.productPricesPerSqm"),
    t("clients.ClientPassportOfferTable.status"),
    t("clients.ClientPassportOfferTable.manage"),
];

export function ClientPassportOffersTable(props) {
    const params = new URLSearchParams();
    if (props.investmentId) {
        params.set("investment", props.investmentId);
    }

    const { data: customerOffers, isLoading, isFetching } = useCustomerOffers(props.customerId, params);
    const [processedOffers, setProcessedOffers] = useState();
    const axiosPrivate = useAxiosPrivate();

    const { openDialog: openFiaskoDialog } = useDialogBetter();
    const handleOpenFiaskoDialog = (offerId, reasonId, reasonNote) => {
        openFiaskoDialog({
          Component: FiaskoEditDialog,
          componentProps: {
            offerId: offerId,
            reasonId: reasonId,
            reasonNote: reasonNote,
          },
        });
      };

    useEffect(() => {
        const processOffers = async () => {
            if (customerOffers) {
                const processed = await Promise.all(
                    customerOffers.results.map(async (offer) => {
                        const productDetails = await Promise.all(
                            offer.products.map(async (p) => {
                                const product = await productsApi.getProduct(
                                    axiosPrivate,
                                    p.product.id,
                                );
                                const pricing = getCalculatedPricingForProductDiscounted(
                                    product,
                                    p.discount_percent,
                                );
                                return {
                                    ...p,
                                    name: product.name_full,
                                    price: pricing.listed.gross,
                                    price_per_sqm: pricing.listed.gross_per_sqm,
                                };
                            }),
                        );

                        const customerStatus = offer.customers.find(
                            (c) => c.customer.id === props.customerId,
                        )?.status;
                        return {
                            rowId: offer.id,
                            data: [
                                // offer.offer_nr,
                                format(new Date(offer.date_created), "yyyy-MM-dd"),
                                offer.investment_name,
                                productDetails.map((p) => p.name).join("\n"),
                                productDetails.map((p) => p.price.toFixed(2)).join("\n"),
                                productDetails.map((p) => p.price_per_sqm.toFixed(2)).join("\n"),
                                customerStatus?.status_key === "RemovedFromOffer" ? (
                                    <OfferStatusText status={customerStatus} />
                                ) : offer.status?.status_key === "Failure" ? (
                                    <div style={{display: "flex", justifyContent: "center"}}> 
                                        <OfferStatusText status={offer.status} />
                                        <InfoIcon style={{cursor: "pointer", marginLeft: "5px"}} onClick={()=>handleOpenFiaskoDialog(offer.id, offer.status_reason?.id, offer.status_note)}/>
                                    </div>
                                    
                                ) : (
                                    <OfferStatusText status={offer.status} />
                                ),
                                <OfferManageButton offer={offer} />,
                            ],
                        };
                    }),
                );
                setProcessedOffers(processed);
            }
        };

        processOffers();
    }, [customerOffers, axiosPrivate, props.customerId]);

    return (
        <Box sx={{ maxHeight: props.maxHeight || 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                stickyHeader={true}
                headers={HEADERS}
                rows={processedOffers || []}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
                showLoader={isLoading || isFetching || !processedOffers}
                colMaxLength={props.colMaxLength}
            />
        </Box>
    );
}
